import { Empty_FlowchartPaper_Interface, FlowchartPaper_Interface } from "./FlowchartPaper_Interface";

export interface DeviceBehfaRef_Interface {
    id:number,
    dsc:String,
    description:String,
    manufacturer:String,
    codeBEHFA:String,
    model:String,
    certificateNo:string,
    calDue:string,
    fullname:string,
    persianDate:string,
    status:number,
    flowchart:FlowchartPaper_Interface
}

export function Empty_DeviceBehfaRef_Interface():DeviceBehfaRef_Interface{
    return{
        id:0,
        dsc:'',
        description:'',
        manufacturer:'',
        codeBEHFA:'',
        model:'',
        certificateNo:'',
        calDue:'',
        fullname:'',
        persianDate:'',
        status:0,
       flowchart:Empty_FlowchartPaper_Interface()
    }
  }